import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import { usePublishButton } from '@components/ArtBoard/Header/components/HeaderControls/components/ShareAndPublish/components/PublishButton/usePublishButton'
import { useShareAndPublish } from '@components/ArtBoard/Header/components/HeaderControls/components/ShareAndPublish/useShareAndPublish'
import { artBoardActions } from '@store/reducers/artboard'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { useProjectAccess } from '@/hooks'
import { PROJECT_SETTINGS_PERMISSION } from '@/permissions/project/definitions'
import { useShare } from '../../../ShareAndPublish/components/Share/useShare'

export const useSettingsDropdown = () => {
  const dispatch = useDispatch()

  const { showShare, showPublish } = useShareAndPublish()

  const { hasNotAvailableAccessBadge } = useProjectAccess(
    PROJECT_SETTINGS_PERMISSION.COLOR_LIBRARY_TAB
  )

  const {
    hasNotAvailableAccess,
    hasPassword,
    projectIsOnlyForMembers,
    onShareClick,
  } = useShare()

  const { handleClick } = usePublishButton()

  const handleClickSettings = () => {
    dispatch(artBoardActions.changeMode('settings'))
  }

  const handleClickColors = (closeDropdown: () => void) => {
    if (hasNotAvailableAccessBadge) {
      return
    }

    dispatch(artBoardActions.changeMode('color'))

    sendGtmEvent(GtmTriggerName.UPGRADE_COLORS)
    closeDropdown()
  }

  const handleClickSymbols = (closeDropdown: () => void) => {
    if (hasNotAvailableAccessBadge) {
      return
    }

    dispatch(artBoardActions.changeMode('symbol_library'))

    sendGtmEvent(GtmTriggerName.UPGRADE_SYMBOLS)
    closeDropdown()
  }

  const handleBadgeClick = () => {
    dispatch(openModal(MODAL_UPGRADE_PLAN))
  }

  return {
    hasNotAvailableAccessShare: hasNotAvailableAccess,
    hasPassword,
    projectIsOnlyForMembers,
    hasNotAvailableAccessBadge,
    showShare,
    showPublish,
    onShareClick,
    onPublishClick: handleClick,
    handleClickSettings,
    handleClickColors,
    handleClickSymbols,
    handleBadgeClick,
  }
}
